import { Component, OnInit, Output, Input, EventEmitter, OnChanges } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { ROLE, User } from 'app/user';
import { NotifyService, ToastType } from 'app/notify';
import { EMPTY_MESSAGE } from '../empty-message.const';

@Component({
  selector: 'app-drag-and-drop',
  templateUrl: './drag-and-drop.component.html',
  styleUrls: ['./drag-and-drop.component.scss']
})
export class DragAndDropComponent implements OnInit, OnChanges {

  @Output()
  public onQuery: EventEmitter<string> = new EventEmitter();
  @Output()
  public onSelectedUsersQuery: EventEmitter<User[]> = new EventEmitter();
  @Input()
  public suggestions: User[] = [];
  @Input()
  public selectedUsers: User[] = [];
  @Input()
  public inputFilterName: string = '';
  @Input()
  public isPreview: boolean = false;

  public dragAndDropForm: FormGroup = null;
  public draggedUser: any = null;
  public emptyMessageKey = EMPTY_MESSAGE.NOT_FOUND;

  constructor(
    private notify: NotifyService,
    private translateService: TranslateService
  ) {
    this.dragAndDropForm = new FormGroup({
      name: new FormControl('')
    });
  }

  ngOnInit() {
    this.dragAndDropForm.get('name').valueChanges
    .debounceTime(1000)
    .subscribe(() => {
      this.filterItems(this.dragAndDropForm.get('name').value);
    });
  }

  ngOnChanges() {
    if (0 === this.suggestions.length) {
      return;
    }

    this.removeSelectedUserFromSuggestions();
  }

  public dragStart(user: any): void {
    this.draggedUser = user;
  }

  public dragEnd(): void {
    this.draggedUser = null;

    this.removeSelectedUserFromSuggestions();
  }

  public filterParticipantRole(user: User) {
    if (!user.hasParticipantRole()) {
      return 'drag-and-drop-user-error';
    }
  }

  public drop(): void {
    this.dropElements();

    //concat for refresh primeNG drag&drop
    this.selectedUsers = [].concat(this.selectedUsers);

    this.sendUsers();
  }

  public deleteUserFromSelected(user: User): void {
    const index = this.findIndex(user);
    this.selectedUsers = this.selectedUsers.filter((selectedUser, i) => i !== index);
    this.notify.toast(ToastType.SUCCESS, this.translateService.instant('session.form.message.participant.deleted'));
    this.sendUsers();
  }

  private getUsersId(): any[] {
    return this.selectedUsers
      .map(user => user.getId());
  }

  private filterItems(query: string): void {
    this.onQuery.emit(query);
  }

  private sendUsers(): void {
    this.onSelectedUsersQuery.emit(this.selectedUsers);
  }

  private findIndex(user: User): number {
    let index: number = -1;

    for (let i = 0; i < this.selectedUsers.length; i++) {
      if (user.getId() === this.selectedUsers[i].getId()) {
        index = i;

        break;
      }
    }

    return index;
  }

  private dropElements(): void {
    for (const user of this.draggedUser.getDragAndDropElements()) {
      if (this.findIndex(user) === -1) {
        this.selectedUsers.push(user);

        continue;
      }

      this.notify.toast(ToastType.WARN, this.translateService.instant('session.form.message.participant.already_exist'));
    }
  }

  private removeSelectedUserFromSuggestions(): void {
    this.suggestions = this.suggestions.filter(
        user => this.getUsersId().indexOf(user.getId()) === -1);
  }
}



// WEBPACK FOOTER //
// /dist/src/app/shared/drag-and-drop/drag-and-drop.component.ts